import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, Link } from 'react-router-dom';

const Footer = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const handleSmoothScroll = (event, targetId) => {
    event.preventDefault(); 
    const targetElement = document.querySelector(targetId);
    if (targetElement) {
      const offsetTop = targetElement.getBoundingClientRect().top + window.scrollY - 120; 
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth',
      });
    }
  };

  const handleNavigation = (event, targetId) => {
    event.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        handleSmoothScroll(event, targetId);
      }, 100); 
    } else {
      handleSmoothScroll(event, targetId);
    }
  };

  return (
    <footer className="bg-[#111111] ">
      <div className="mx-auto px-5 max-w-[1290px] w-full p-24 lg:flex flex-col flex lg:flex-row justify-between lg:gap-[100px] gap-[50px]">
        
        <div className="lg:w-7/8 w-full gap-[32px] flex flex-col">
          <div className="flex flex-col gap-[16px]">
            <img src="/images/Logo 2.jpg" alt="Logo" className="w-[168px]" />
            <span className="text-[#DCDCDC] leading-[20.8px] text-[16px] font-[400]">{t('hero.description')}</span>
          </div>
          <div className='flex gap-4'>
           <a href="https://www.customs.gov.mk/ovlasten-ekonomski-operator.nspx"><img src="/images/aeomk.png" alt="" className='w-[47.53px] h-[41.1px]'/></a> 
            <a href="https://www.mifa.org.mk/mk"><img src="/images/mifa.png" alt="" className='w-[82.79px] h-[41px]'/></a>
            <a href="https://malmed.gov.mk/%d0%bb%d0%b5%d0%ba%d0%be%d0%b2%d0%b8-%d1%81%d0%be-
%d0%bf%d0%b0%d1%80%d0%b0%d0%bb%d0%b5%d0%bb%d0%b5%d0%bd-
%d1%83%d0%b2%d0%be%d0%b7/"><img src="/images/malmed.jpg" alt="" className='w-[82.79px] h-[41px]'/></a>
          </div>
          <div className='lg:flex hidden'>
            <p className='text-[#B0B0B0] font-[400] text-[16px] leading-[20.8px] lg:mt-20 mt-5'>{t('footer.@')}</p>
          </div>
        </div>

        <div className="lg:w-1/3 w-full">
          <h4 className="text-[#FBFBFB] text-[16px] leading-[20.8px] font-bold mb-4">{t('footer.links.links')}</h4>
          <ul>
            <li className="mb-2">
              <a 
                href="/" 
                className="text-[13.33px] font-[400] leading-[17.33px] text-[#DCDCDC]"
              >
                {t('footer.links.home')}
              </a>
            </li>
            <li className="mb-2">
              <a 
                href="/"
                className="text-[13.33px] font-[400] leading-[17.33px] text-[#DCDCDC]"
                onClick={(event) => handleNavigation(event, '#services')}
              >
                {t('footer.links.services')}
              </a>
            </li>
            <li className="mb-2">
              <a 
                href="/"
                className="text-[13.33px] font-[400] leading-[17.33px] text-[#DCDCDC]"
                onClick={(event) => handleNavigation(event, '#team')}
              >
                {t('footer.links.ourTeam')}
              </a>
            </li>
            <li className="mb-2">
              <Link to="/contactus" className="text-[13.33px] font-[400] leading-[17.33px] text-[#DCDCDC]">
                {t('footer.links.contact')}
              </Link>
            </li>
            <li className="mb-2">
              <Link to="/news" className="text-[13.33px] font-[400] leading-[17.33px] text-[#DCDCDC]">
                {t('footer.links.news')}
              </Link>
            </li>
          </ul>
        </div>
        <div className="lg:w-1/3 w-full">
          <h4 className="text-[#FBFBFB] text-[16px] leading-[20.8px] font-bold mb-4">{t('footer.links.aboutCompany')}</h4>
          <ul>
            <li className="mb-2">
              <a 
                href="/"
                className="text-[13.33px] font-[400] leading-[17.33px] text-[#DCDCDC]"
                onClick={(event) => handleNavigation(event, '#about-us')}
              >
                {t('footer.links.aboutUs')}
              </a>
            </li>
            <li className="mb-2">
              <a 
                href="/"
                className="text-[13.33px] font-[400] leading-[17.33px] text-[#DCDCDC]"
                onClick={(event) => handleNavigation(event, '#team')}
              >
                {t('footer.links.ourTeam')}
              </a>
            </li>
            <li className="mb-2">
              <a 
                href="/"
                className="text-[13.33px] font-[400] leading-[17.33px] text-[#DCDCDC]"
                onClick={(event) => handleNavigation(event, '#clients')}
              >
                {t('footer.links.clients')}
              </a>
            </li>
          </ul>
        </div>
        <div className="lg:w-[44%] w-full">
          <h4 className="text-[#FBFBFB] text-[16px] leading-[20.8px] font-bold mb-4">{t('footer.links.workingTime')}</h4>
          <ul>
            <li className="mb-4">
              <p className="text-[13.33px] font-[400] leading-[17.33px] text-[#DCDCDC]">
                {t('footer.links.workingDays')}: 8:30 - 16:30
              </p>
            </li>
            <li className="mb-2">
              <p className="text-[13.33px] font-[400] leading-[17.33px] text-[#DCDCDC]">
                {t('footer.links.saturday')}: 9:00 - 13:00
              </p>
            </li>
          </ul>
        </div>
        <div className='flex lg:hidden'>
          <p className='text-[#B0B0B0] font-[400] text-[16px] leading-[20.8px] lg:mt-20 mt-5'>{t('footer.@')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
